const namespace = 'APP';
export const TOOGLE_SIDEBAR = `${namespace}_TOOGLE_SIDEBAR`;
export const TOOGLE_LOADING = `${namespace}_TOOGLE_LOADING`;

export const toogleSidebar = () => ({
  type: TOOGLE_SIDEBAR,
});

export const toogleLoading = () => ({
  type: TOOGLE_LOADING,
});
